import { FlatTreeControl } from '@angular/cdk/tree';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AuthService,
  BaseSiteService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core';
import { of, Subscription, Subject } from 'rxjs';
import { debounceTime, filter, map, take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import * as _ from 'underscore';
import { SharedService } from '../../services/shared.service';
import { FutureCartService } from '../future-cart/future-cart.service';
import { LoactionStripService } from './loaction-strip.service';

@Component({
  selector: 'app-location-strip',
  templateUrl: './location-strip.component.html',
  styleUrls: ['./location-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationStripComponent implements OnInit, DoCheck, OnDestroy {
  usergetDataObj: any;
  shippingLocations: Array<any>;
  shippingLocationsCopy: Array<any>;
  selectedLocs: Array<any>;
  subscriptions = [];

  showChangeOption = true;
  showLocationSelector = false; //keeping it undefined was showing the location strip before login in ASM
  isMultiSelectionPossible = true;
  routesWhereNoSelector = [
    'vaccinesforchildren',
    'immunizationschedules',
    'patientEducation',
    'invoices',
    'cart',
    'vaccineLocatorPage',
    'checkout',
    'reportDashboardPage',
    'statements',
    'transactionaldata',
    'futureShipLayoutPage',
    '/my-account/order/',
    'customer-hierarchy',
    'about-vaxserve',
    'solutions/data-solutions',
    'solutions/operational-solutions',
    'solutions/consultative-solutions',
    'solutions/cost-savings-solutions',
    'reimbursementBillingAndCodingPage',
    'reimburseSupportServicePage',
    'sanofiRulesPage',
    'stsAdminCustomerInfo',
    'tiermanagementpage',
    'stsAdminShippingWeekPage',
    'shipCommitmentPage',
    'stsMarketingAnalysisPage',
    'stsOrderExportPage',
    'contactUsVaxServePage',
    'my-company/pending-orders',
    '/openInvoicePayment',
    '/openInvoicePaymentReview',
    '/openInvoicePaymentConfirmation',
    '/invoicecreditselection',
    'futurePayPayAtTerms',
    'futurePayPayAtTermsReview',
    'futurePayPayAtTermsConfirmation',
  ];
  // add routes where loc selector needs to be hidden.
  routesWithoutChangeOption = [
    'recurringPage',
    'fluCategoryPage',
    'FluverifypaymentPage',
    'fluStsLandingPage',
    'orderConfirmationFlu',
    'influenza/reservation-overview',
  ]; /* routes where
  change option is hidden */
  routesWithSingleSelection = ['profile', 'messageHistoryPage', 'influenza/dashboard', 'waitlist', 'resources/category/requestResourcespage', 'resources/category/requestResourcesConfirmationpage', 'returnpage', 'notificationsmessageDetailsPage', 'offers']; /* routes which support only
  single selection ; Returns route needs to be checked after rebranding. */

  routesWithQtyRestrictions = [
    'Open-Catalogue',
    'Open-Catalog',
    'product',
    'Product-Catalogue',
    'Product-Catalog',
    'my-account/account-overview',
    'fluCategoryPage',
  ];
  @ViewChild('content') modalContent;

  testxxx: Array<any>;
  _testxxx: Array<any>;
  // /** Flat node with expandable and level information */

  _transformer = (node, level: number) => {
    return {
      expandable: !!node.shipToAddresses?.length || !!node.childNodes?.length,
      name: node.name,
      level: level,
      uid: node.uid,
      index: node.index,
      govLocation: node.isGovernmentLocation,
      facilityName: node.companyName,
      accountNumber: node.accountNumber,
      formattedAddress: node.formattedAddress?.replace(/(,\s,)/g, ','),
      phoneNo: node.phone,
      checked: node.checked,
      searchText:
        node.companyName +
        node.formattedAddress +
        node.phone +
        node.accountNumber,
      visible: node.visible,
    };
  };

  treeControl = new FlatTreeControl<any>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.shipToAddresses || node.childNodes
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node) => node.expandable;
  fluDashboardNegativeScenario = false;


  private readonly destroy$ = new Subject<void>();

  constructor(
    protected readonly locService: LoactionStripService,
    protected cd: ChangeDetectorRef,
    protected router: Router,
    protected authService: AuthService,
    protected customProfileService: CustomProfileAndPreferencesService,
    protected modal: NgbModal,
    private readonly baseSiteService: BaseSiteService,
    private readonly sharedService: SharedService,
    private readonly futureCartService: FutureCartService,
    private readonly globalMsgService: GlobalMessageService
  ) { }
  defaultLocation: any;
  baseSiteId: string;
  isDefaultLocationGovt: boolean = false;
  showDefaultLocation: boolean;
  userName: string;
  loggedInCustomer: string;
  isPunchout: boolean;
  showStrip = false;
  routerSub: Subscription;
  baseSub: Subscription;

  // USONESHOP-101: Needed for opening the modal when landing on offers page.
  hideReturnText: boolean = false;

  ngOnInit(): void {
    // distinctUntilChanged((prev:any,curr:any) => prev.url === curr.url)
    this.routerSub = this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd && !e.url.includes('logout'))
      )
      .subscribe((navigationEventObj: any) => {
        this.authService
          .isUserLoggedIn()
          .pipe(take(1))
          .subscribe((loggedInRes: any) => {
          this.showDefaultLocation = false;

          if (loggedInRes && !navigationEventObj.url.includes('homepage')) {
              this.customProfileService._userAccountData
                .pipe(
                  filter((res) => !!res),
                  map(({ defaultB2BUnit, userName }) => ({
                    accountId: defaultB2BUnit.uid,
                    userName,
                    isPayer: defaultB2BUnit.payer,
                    locations: defaultB2BUnit.shippingAddresses,
                  })),
                  take(1)
                )
                .subscribe((_res) => {
                this.userName = _res.userName;
                this.loggedInCustomer = _res.accountId;
                  sessionStorage.setItem(
                    'isLoggedInPayer',
                    JSON.stringify(_res.isPayer)
                  );
                  this.customProfileService.userAccountDetails
                    .pipe(
                      filter((a) => !!a),
                      map(({ res }) => res),
                      take(1)
                    )
                    .subscribe((aa) => {
                  if (localStorage.getItem('punchout-sid-key') == null) {
                        this.sharedService.setLocalStorage(
                          'futureShip',
                          aa?.futureShip
                        );
                      } else {
                    this.sharedService.setLocalStorage('futureShip', false);
                  }

                      'selectedLocations' in sessionStorage &&
                      JSON.parse(sessionStorage.getItem('selectedLocations'))
                        .length > 1
                        ? [
                            'formularyCustomer',
                            'YFAuthorized',
                            'blockOrder',
                          ].forEach((l) =>
                            this.sharedService.setLocalStorage(l, false)
                          )
                        : (this.sharedService.setLocalStorage(
                            'formularyCustomer',
                            aa?.customerSalesAreaData?.formularyCustomer
                          ),
                          this.sharedService.setLocalStorage(
                            'YFAuthorized',
                            aa?.yellowFeverFlag
                          ),
                          this.sharedService.setLocalStorage(
                            'blockOrder',
                            aa?.customerSalesAreaData?.blockOrder
                          ));

                  let blockOrderErrorMsg =
                        this.baseSiteId == 'vsh'
                          ? `Account ${aa.uid}: An order cannot be placed on this account. Please select a different shipping location. If you believe this is an error, please call 1-800-VACCINE (1-800-822-2463) for further assistance.`
                      : `Account ${aa.uid}: An order cannot be placed on this account. Please select a different shipping location. If you believe this is an error, please call 1-800-752-9338 for further assistance.`;
                      this.sharedService.getLocalStorage('blockOrder') &&
                      [
                        'Product-Catalog',
                        'account-overview',
                        'search',
                        'influenza/dashboard',
                        'Open-Catalogue',
                      ].some((route) => navigationEventObj.url.includes(route))
                        ? this.globalMsgService.add(
                            blockOrderErrorMsg,
                            GlobalMessageType.MSG_TYPE_ERROR,
                            90000
                          )
                        : this.globalMsgService.remove(
                            GlobalMessageType.MSG_TYPE_ERROR
                          );

                      aa?.customerSalesAreaData?.paymentTerms &&
                        this.sharedService.setLocalStorage(
                          'paymentTerms',
                          aa?.customerSalesAreaData?.paymentTerms
                        );
                      aa?.customerSalesAreaData?.paymentPreference &&
                        this.sharedService.setLocalStorage(
                          'paymentPreference',
                          aa?.customerSalesAreaData?.paymentPreference
                        );
                      aa?.customerSalesAreaData?.deliveryHours &&
                        this.sharedService.setLocalStorage(
                          'deliveryHoursWaitList',
                          aa?.customerSalesAreaData?.deliveryHours
                        );
                      this.sharedService.setLocalStorage(
                        'isGovtCustomer',
                        aa?.govtCustomer
                      );
                  // this.sharedService.setSessionStorage('firewallExempt', aa?.firewallExempt);

                      if (
                        aa?.customerSalesAreaData?.isCustomerRestricted &&
                        this.routesWithQtyRestrictions.some((route) =>
                          navigationEventObj.url.includes(route)
                        )
                      ) {
                        this.sharedService
                          .fetchProductAllocations(_res.userName, aa?.uid)
                          .pipe(take(1))
                          .subscribe((prods) => {
                            this.sharedService.setSessionStorage(
                              'productAllocations',
                              prods.hasOwnProperty('productAllocations')
                                ? prods.productAllocations
                                : {}
                            );
                    });
                  }

                      this.sharedService.setLocalStorage(
                        'accountId',
                        _res.accountId
                      );
                  if (!!this.sharedService.getLocalStorage('futureShip')) {
                        this.customProfileService.futureShipFlagEmitted.next(
                          true
                        );
                        this.futureCartService.getFutureShipCarts(
                          _res.userName,
                          aa.uid
                        );
                      } else {
                        this.customProfileService.futureShipFlagEmitted.next(
                          false
                        );
                    this.futureCartService.getFutureShipCarts();
                  }

                  ///****************////
                  //set default location
                      this.defaultLocationInList = JSON.parse(
                        sessionStorage.getItem('defaultLocInList')
                      );
                      this.defaultLocation = JSON.parse(
                        sessionStorage.getItem('defaultLocation')
                      );

                  if (!this.defaultLocation?.length) {
                        const defaultLoc =
                          +this.loggedInCustomer ===
                          +aa.payerAddress?.accountNumber
                            ? [aa.payerAddress]
                            : +this.loggedInCustomer ===
                              +aa.soldToAddress?.accountNumber
                            ? [aa.soldToAddress]
                            : [aa.shippingAddress];

                        const defaultLocInList = _.some(
                          _res.locations,
                          (obj) => {
                            return +obj.accountNumber == +this.loggedInCustomer;
                          }
                        );
                        sessionStorage.setItem(
                          'defaultLocInList',
                          JSON.stringify(defaultLocInList)
                        );
                        sessionStorage.setItem(
                          'defaultLocation',
                          JSON.stringify(defaultLoc)
                        );
                    this.defaultLocationInList = defaultLocInList;
                    this.defaultLocation = defaultLoc;
                  }

                      this.isDefaultLocationGovt =
                        !!this.defaultLocation &&
                        this.defaultLocation[0]?.isGovernmentLocation;

                      !_.isEmpty(_res) &&
                        this.locService
                          .getShipToAddresses(_res.userName, _res.accountId)
                          .pipe(take(1))
                          .subscribe((res: any) => {
                            this.testxxx = JSON.parse(
                              JSON.stringify(
                                _.chain(
                                  res.customerHierarchyList[0]?.childNodes
                                )
                                  .filter((obj) => obj.visible)
                                  .value()
                              )
                            );
                    // filter only the visible nodes
                    this.filterVisibleNodes(this.testxxx);
                    // transform all nested nodes for tree
                            this.testxxx.forEach((node) => {
                              node['expandable'] =
                                !!node.shipToAddresses?.length ||
                                !!node.childNodes?.length;
                      node['level'] = 1;
                      this.transformNode(node, node);
                    });

                    //transform leaf node at root level for tree

                            if (
                              res?.customerHierarchyList[0]?.shipToAddresses
                            ) {
                              const x = _.uniq(
                                res.customerHierarchyList[0].shipToAddresses,
                                (el) => el.accountNumber
                              );
                              x.forEach((obj) =>
                                this.testxxx.push({
                                  ...obj,
                                  expandable: false,
                                  level: 1,
                                })
                              );
                    }

                    // transform all unassigned nodes for tree
                    if (res?.shipToAddresses) {
                              const x = _.uniq(
                                res.shipToAddresses,
                                (el) => el.accountNumber
                              );
                              x.forEach((obj) =>
                                this.testxxx.push({
                                  ...obj,
                                  expandable: false,
                                  level: 1,
                                })
                              );
                    }

                            !this.defaultLocationInList &&
                              !!this.testxxx &&
                              ['profile', 'paymenthistory'].some((r) =>
                                navigationEventObj.url.includes(r)
                              ) &&
                              this.testxxx.unshift(this.defaultLocation[0]);
                            if (
                              !(
                                navigationEventObj.url.includes('profile') ||
                                navigationEventObj.url.includes(
                                  'paymenthistory'
                                )
                              )
                            ) {
                              const selectedLocations = JSON.parse(
                                sessionStorage.getItem('selectedLocations')
                              );
                              const indexOfDefaultLoc =
                                selectedLocations?.length &&
                                selectedLocations.indexOf(
                                  selectedLocations.find(
                                    (el) =>
                                      el.accountNumber ==
                                      this.defaultLocation[0].accountNumber
                                  )
                                );
                              if (
                                !this.defaultLocationInList &&
                                indexOfDefaultLoc >= 0
                              ) {
                        selectedLocations.splice(indexOfDefaultLoc, 1);
                        sessionStorage.removeItem('selectedLocations');
                                !!selectedLocations.length &&
                                  sessionStorage.setItem(
                                    'selectedLocations',
                                    JSON.stringify(selectedLocations)
                                  );
                      }
                    }

                            this._testxxx = JSON.parse(
                              JSON.stringify(this.testxxx)
                            );

                            this.isPunchout =
                              localStorage.getItem('punchout-sid-key') !== null;

                            this.isMultiSelectionPossible = !(
                              this.routesWithSingleSelection.some((route) =>
                                navigationEventObj.url.includes(route)
                              ) || this.isPunchout
                            );

                    if (this.testxxx?.length === 1) {
                              const filteredLocations = this.pluckShipTo(
                                this.testxxx[0]
                              );
                              this.showChangeOption = !(
                                filteredLocations?.length == 1 ||
                                this.routesWithoutChangeOption.some((route) =>
                                  navigationEventObj.url.includes(route)
                                )
                              );
                      if (filteredLocations?.length == 1) {
                                this.locService.emitSelectedLocs.next(
                                  filteredLocations
                                );
                                this.selectedLocs = filteredLocations;
                              } else {
                                this.selectedLocs =
                                  JSON.parse(
                                    sessionStorage.getItem('selectedLocations')
                                  ) || [];
                                !this.isMultiSelectionPossible
                                  ? this.selectedLocs?.length == 1
                                    ? this.locService.emitSelectedLocs.next(
                                        this.selectedLocs
                          )
                                    : !this.isPunchout &&
                                      this.locService.emitSelectedLocs.next(
                                        this.defaultLocation
                                      )
                                  : !this.showChangeOption &&
                                    (navigationEventObj.url.includes(
                                      'recurringPage'
                                    ) ||
                                      (this.routesWithoutChangeOption.some(
                                        (route) =>
                                          navigationEventObj.url.includes(route)
                                      ) &&
                                        this.selectedLocs.length > 1))
                                  ? ((this.showDefaultLocation = true),
                                    this.locService.emitSelectedLocs.next(
                                      this.defaultLocation
                                    ))
                                  : this.locService.emitSelectedLocs.next(
                                      this.selectedLocs
                        );
                      }
                              sessionStorage.setItem(
                                'selectedLocations',
                                JSON.stringify(this.selectedLocs)
                              );
                            } else {
                              this.showChangeOption =
                                !this.routesWithoutChangeOption.some((route) =>
                                  navigationEventObj.url.includes(route)
                                );
                              this.selectedLocs =
                                JSON.parse(
                                  sessionStorage.getItem('selectedLocations')
                                ) || [];
                              !this.isMultiSelectionPossible
                                ? this.selectedLocs?.length == 1
                                  ? this.locService.emitSelectedLocs.next(
                                      this.selectedLocs
                                    )
                                  : !this.isPunchout &&
                                    this.locService.emitSelectedLocs.next(
                                      this.defaultLocation
                        )
                                : !this.showChangeOption &&
                                  (navigationEventObj.url.includes(
                                    'recurringPage'
                                  ) ||
                                    (this.routesWithoutChangeOption.some(
                                      (route) =>
                                        navigationEventObj.url.includes(route)
                                    ) &&
                                      this.selectedLocs.length > 1))
                                ? ((this.showDefaultLocation = true),
                                  this.locService.emitSelectedLocs.next(
                                    this.defaultLocation
                                  ))
                                : this.locService.emitSelectedLocs.next(
                                    this.selectedLocs
                      );
                            }

                            this.fluDashboardNegativeScenario =
                              navigationEventObj.url.includes(
                                'influenza/dashboard'
                              ) &&
                              !this.defaultLocationInList &&
                              (!this.selectedLocs?.length ||
                                this.selectedLocs.length > 1);

                            this.locService.fluDashboardNegativeScenario.next(
                              this.fluDashboardNegativeScenario
                            );

                            this.showLocationSelector = !(
                              this.routesWhereNoSelector.some((route) =>
                                navigationEventObj.url.includes(route)
                              ) ||
                              navigationEventObj.url.split('/').pop() ===
                                'orderConfirmation'
                            );
                            const array = [
                              'showLocationSelector',
                              'showChangeOption',
                              'isMultiSelectionPossible',
                              'isDefaultLocationGovt',
                            ];
                    for (let x of array) {
                              sessionStorage.setItem(
                                `${x}`,
                                JSON.stringify(this[`${x}`])
                              );
                    }
                    this.cd.markForCheck();

                    if (!this.isMultiSelectionPossible && (navigationEventObj.url.includes('returnpage') || navigationEventObj.url.includes('offers')) && (!this.selectedLocs.length || this.selectedLocs.length > 1)) {
                              this.hideCloseBtn = true;
                      this.hideReturnText = navigationEventObj.url.includes('offers');
                              this.openModal(this.modalContent);
                            } else {
                      this.getTitle();

                      // to show the location selector after the DOM is painted.
                    }
                    this.cd.detectChanges(); // to show the location selector after the DOM is painted.
                  });
                });
              });
            } else {
            this.showLocationSelector = false;
            this.modal.dismissAll();
            this.locService.emitSelectedLocs.next([]);
            this.locService.fluDashboardNegativeScenario.next(false);
            this.customProfileService._userAccountData.next(undefined);
            this.customProfileService.userAccountDetails.next('');
            this.testxxx = this._testxxx = this.selectedLocs = [];
            this.defaultLocation = 'Select a location';
              const array = [
                'showLocationSelector',
                'showChangeOption',
                'isMultiSelectionPossible',
                'defaultLocation',
                'isDefaultLocationGovt',
                'selectedLocations',
                'defaultLocInList',
                'isLoggedInPayer',
              ];
            for (let x of array) {
              sessionStorage.removeItem(`${x}`);
            }

            this.cd.detectChanges();
          }

        });
      });
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.locService.openModal$.subscribe((res) => {
      if (res) this.openModal(this.modalContent);
    });
  }

  hideCloseBtn = false;
  ngDoCheck() {
    this.cd.detectChanges();
  }

  openModal(content) {
    this.selectedLocs = JSON.parse(sessionStorage.getItem('selectedLocations'));
    this.hideReturnText = this.router.url.includes('offers');
    this.markLocsOnOpenClose();
    this.modal.open(content, {
      centered: true,
      backdrop: 'static',
      windowClass: `locStripModal ${this.baseSiteId}`,
    });
  }

  //recursive fn to get default location

  getDefaultLoc(node) {
    for (let key in node) {
      if (key == 'shipToAddresses' && !!node[key].length) {
        return node['shipToAddresses'][0];
      } else if (key == 'childNodes' && !!node[key].length) {
        for (let c of node['childNodes']) {
          const index = node['childNodes'].indexOf(c);
          return this.getDefaultLoc(node['childNodes'][index]);
        }
      } else if (key == 'accountNumber') {
        return node;
      }
    }
  }

  // function to pluck only the leaf nodes from a single hierarchical structure or unassigned shipTo(s)
  pluckShipTo(node) {
    for (const key in node) {
      if (key == 'shipToAddresses' && !!node['shipToAddresses'].length) {
        return node['shipToAddresses'];
      } else if (key == 'companyName') {
        return [node];
      }
    }
  }
  defaultLocationInList = false;

  //recursive fn to filter out visible nodes

  //recursive fn
  transformNode(node, rootNode) {
    for (const key in node) {
      if (key == 'shipToAddresses' && !!node['shipToAddresses'].length) {
        for (const s of node['shipToAddresses']) {
          s['level'] = node['level'] + 1;
          s['expandable'] = false;
        }
        rootNode['hasGovernmentLocs'] = node['shipToAddresses'].some(
          (l) => l.isGovernmentLocation
        );
        return;
      } else if (key == 'childNodes' && !!node['childNodes'].length) {
        for (let c of node['childNodes']) {
          const index = node['childNodes'].indexOf(c);
          node['childNodes'].splice(index, 1, {
            ...c,
            expandable: !!c.shipToAddresses?.length || !!c.childNodes?.length,
            level: node['level'] + 1,
          });
          // invokes the method again to check the inner nodes
          this.transformNode(node['childNodes'][index], rootNode);
        }
      }
    }
  }

  //recursive fn to filter out only the visible nodes
  filterVisibleNodes(array) {
    array.forEach((n) => {
      if (!!n.childNodes.length) {
        n.childNodes = _.chain(n.childNodes)
          .filter((o) => o.visible)
          .value();

        this.filterVisibleNodes(n.childNodes);
      } else {
        return;
      }
    });
  }

  showOnlyGovLocs = false;

  // recursive fn to mark locations on select

  selectEachLoc(node, action, accNoArray: Array<string>) {
    for (let key in node) {
      if (key == 'shipToAddresses' && !!node[key].length) {
        for (let s of node['shipToAddresses']) {
          if (accNoArray.includes(s.accountNumber)) s['checked'] = action;
          else {
            if (!this.isMultiSelectionPossible) s['checked'] = false;
          }
        }
        return;
      } else if (key == 'childNodes' && !!node[key].length) {
        for (let n of node['childNodes']) {
          const index = node['childNodes'].indexOf(n);
          this.selectEachLoc(node['childNodes'][index], action, accNoArray);
        }
      } else if (key == 'accountNumber') {
        if (accNoArray.includes(node['accountNumber'])) {
          node['checked'] = action;
        } else {
          if (!this.isMultiSelectionPossible) {
            node['checked'] = false;
          }
        }
        // this.cd.markForCheck();
        return;
      }
    }
  }
  //recursive fn
  selectAllLocs(node, action) {
    for (let k in node) {
      if (k == 'shipToAddresses' && !!node['shipToAddresses'].length) {
        node['checked'] = action;
        for (let s of node['shipToAddresses']) {
          s['checked'] = action;
        }
        return;
      } else if (k == 'childNodes' && !!node['childNodes'].length) {
        for (let n of node['childNodes']) {
          node['checked'] = action;
          const index = node['childNodes'].indexOf(n);
          this.selectAllLocs(node['childNodes'][index], action);
        }
      } else if (k == 'accountNumber') {
        node['checked'] = action;
        return;
      }
    }
  }
  allLocsChecked = false;
  filterLocations(event, selected, shipTo?) {
    switch (event.currentTarget.checked) {
      case true:
        if (selected.toLowerCase() == 'selectall') {
          this.testxxx = JSON.parse(JSON.stringify(this._testxxx));
          this.showOnlyGovLocs = false;
          this.testxxx.forEach((node) => this.selectAllLocs(node, true));
          this.dataSource.data = this.testxxx;
          (
            document.querySelector(
              "input[type='checkbox'][name=gov]"
            ) as HTMLInputElement
          ).checked = false;
          this.allLocsChecked = true;
          this.cd.detectChanges();
        } else if (selected.toLowerCase() == 'gov') {
          this.dataSource.data = this.testxxx = JSON.parse(
            JSON.stringify(
              this._testxxx.filter(
                (obj) => obj.hasGovernmentLocs || obj.isGovernmentLocation
              )
            )
          );
          this.showOnlyGovLocs = true;
          this.treeControl.expandAll();
          (
            document.querySelector(
              "input[type='checkbox'][name=all]"
            ) as HTMLInputElement
          ).checked = false;
          this.cd.detectChanges();
        } else {
          this.testxxx.forEach((node) =>
            this.selectEachLoc(node, true, [shipTo.accountNumber])
          );
          this.dataSource.data = this.testxxx;
          this.searchKeyword && this.searchLoc(this.searchKeyword);
        }
        break;
      case false:
        this.showOnlyGovLocs = false;
        if (selected.toLowerCase() == 'selectall') {
          this.testxxx.forEach((node) => this.selectAllLocs(node, false));
          this.dataSource.data = this._testxxx = JSON.parse(
            JSON.stringify(this.testxxx)
          );
        } else if (selected.toLowerCase() == 'individualloc') {
          this.testxxx.forEach((node) =>
            this.selectEachLoc(node, false, [shipTo.accountNumber])
          );
          this.dataSource.data = this.testxxx;
          this.searchKeyword && this.searchLoc(this.searchKeyword);
          if (this.allLocsChecked) {
            (
              document.querySelector(
                "input[type='checkbox'][name=all]"
              ) as HTMLInputElement
            ).checked = false;
            this.cd.detectChanges();
            this.allLocsChecked = false;
          }
        } else {
          this.dataSource.data = this.testxxx = JSON.parse(
            JSON.stringify(this._testxxx)
          );
          this.showOnlyGovLocs = false;
        }
        break;
    }
    if (shipTo) {
      this.treeControl.dataNodes.forEach((n, i) => {
        this.treeControl.getDescendants(n).forEach((subNode) => {
          !subNode.expandable &&
            subNode.accountNumber == shipTo.accountNumber &&
            this.treeControl.expandDescendants(this.treeControl.dataNodes[i]);
        });
      });
      this.cd.detectChanges();
    }
  }
  //recursive fn
  expandCollapseSubTree(node, action, selectedNode, parentName) {
    for (let key in node) {
      if (key == 'name' && node[key] == selectedNode.name) {
        this.selectAllLocs(node, action);
        this.dataSource.data = this.testxxx;
        //expand or collpase subtree based on event
        this.treeControl.dataNodes.forEach((n) => {
          if (!!n.expandable && n.name === parentName) {
            this.treeControl.expandDescendants(n);
          }
          !action &&
            n.name == node.name &&
            this.treeControl.collapseDescendants(n);
        });

        return;
      } else if (
        key == 'childNodes' &&
        !!node[key].length &&
        node['name'] !== selectedNode.name
      ) {
        for (let c of node['childNodes']) {
          this.expandCollapseSubTree(c, action, selectedNode, parentName);
        }
      }
    }
  }

  selectChilds(event, node) {
    this.testxxx.forEach((n) => {
      this.expandCollapseSubTree(n, event.currentTarget.checked, node, n.name);
    });
    this.cd.detectChanges();
  }

  //recursive fn to filter out only the selected locations from the list
  getSelectedLocs(node) {
    for (let k in node) {
      if (k == 'shipToAddresses' && !!node[k].length) {
        let returnedValues = [];
        for (let s of node['shipToAddresses']) {
          returnedValues?.push(s.checked && s);
        }
        return returnedValues;
      } else if (k == 'childNodes' && !!node[k].length) {
        let ss = [];
        for (let c of node['childNodes']) {
          const index = node['childNodes'].indexOf(c);
          ss.push(this.getSelectedLocs(node['childNodes'][index]));
          if (index == node['childNodes'].length - 1) {
            return ss;
          }
        }
      } else if (k == 'accountNumber') {
        return node.checked && node;
      }
    }
  }
  showError = false;
  updateLocation() {
    let govLocsCount = 0;
    const selections = JSON.parse(
      JSON.stringify(
        _.chain(this.testxxx)
          .map((obj) => this.getSelectedLocs(obj))
      .flatten()
          .filter((res) => !!res)
          .value()
      )
    );

    govLocsCount = selections.filter((obj) => obj.isGovernmentLocation).length;

    if (
      !govLocsCount ||
      (govLocsCount == 1 && govLocsCount == selections.length)
    ) {
      this.showError = false;
      this.selectedLocs = JSON.parse(JSON.stringify(selections));
      sessionStorage.removeItem('selectedLocations');
      sessionStorage.setItem(
        'selectedLocations',
        JSON.stringify(this.selectedLocs)
      );
      this.locService.emitSelectedLocs.next(this.selectedLocs);
      if (
        [
          'product',
          'Product-Catalog',
          'Open-Catalog',
          'Open-Catalogue',
          'Product-Catalogue',
          'search',
        ].some((r) => location.href.includes(r))
      ) {
        location.href = location.href;
      } else {
        const index = window.location.pathname.indexOf('USD');
        const route = window.location.pathname.slice(index + 3);
        this.customProfileService.userAccountDetails.next('');
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([route]);
        this.customProfileService.getUserAccountDetailsDataFromDb(
          this.userName,
          selections.length == 1
            ? selections[0].accountNumber
            : JSON.parse(sessionStorage.getItem('defaultLocation'))[0]
                ?.accountNumber
        );
      }

      this.searchKeyword = null;
      this.modal.dismissAll();
    } else {
      this.showError = true;
    }
    this.hideReturnText = false;
  }

  getTitle() {
    if (!this.showChangeOption) {
      if (this.showDefaultLocation || !this.selectedLocs.length) {
        return (
          this.defaultLocation[0]?.companyName +
          '...(' +
          this.defaultLocation[0]?.accountNumber +
          ')'
        ).toUpperCase();
      } else {
        return (
          this.selectedLocs[0]?.companyName +
          '...(' +
          this.selectedLocs[0]?.accountNumber +
          ')'
        ).toUpperCase();
      }
    } else if (!this.isMultiSelectionPossible) {
      if (
        this.fluDashboardNegativeScenario ||
        (this.isPunchout && !this.selectedLocs?.length)
      )
        return 'Select a location';
      else if (this.selectedLocs?.length == 1)
        return (
          this.selectedLocs[0]?.companyName +
          '...(' +
          this.selectedLocs[0]?.accountNumber +
          ')'
        ).toUpperCase();
      else
        return (
          this.defaultLocation[0]?.companyName +
          '...(' +
          this.defaultLocation[0]?.accountNumber +
          ')'
        ).toUpperCase();
    } else {
      if (this.selectedLocs?.length) {
        if (this.selectedLocs.length > 1)
          return `Multiple locations (${this.selectedLocs.length})`;
        else
          return (
            this.selectedLocs[0]?.companyName +
            '...(' +
            this.selectedLocs[0]?.accountNumber +
            ')'
          ).toUpperCase();
      } else return 'Select a location';
    }
    }

  noResults = false;
  searchKeyword = null;
  searchLoc(keyword) {
    of(keyword)
      .pipe(debounceTime(3000))
      .subscribe((res) => {
        this.noResults = false;

        this.dataSource.data = this.testxxx = !this.showOnlyGovLocs
          ? this._testxxx
          : this._testxxx.filter(
              (obj) => obj.hasGovernmentLocs || obj.isGovernmentLocation
            );
        if (res) {
          this.treeControl.dataNodes.forEach((n, i) => {
            if (!n.expandable && n.level == 0 && (n.searchText && n.searchText.toLowerCase().indexOf(keyword.toLowerCase()) == -1)) {
              n['display'] = 'none';
            }
            if (n.expandable && n.level == 0) {
              const noSearchResult = this.treeControl
                .getDescendants(n)
                .every(_n =>
                  (_n.expandable && _n.name?.toLowerCase().indexOf(keyword.toLowerCase()) == -1) ||
                  (!_n.expandable && (_n.searchText && _n.searchText.toLowerCase().indexOf(keyword.toLowerCase()) == -1))
                );

              if (noSearchResult) {
                n['display'] = 'none';
              } else {
                this.lookForAMatch(keyword, n); //pass only the root nodes
              }
            }
          });
          this.noResults = this.treeControl.dataNodes
            .filter((n) => n.level == 0)
            .every((node) => node.display === 'none');
          this.cd.detectChanges();
        } else {
          this.treeControl.collapseAll();
        }
      });
  }

  lookForAMatch(keyword, node) {
    // here node will be an expandable root node 
    this.treeControl.getDescendants(node).forEach((n) => {
      if (n.expandable) {
        if (n.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
          [node, n].forEach((i) => this.treeControl.expand(i));
          n['display'] = 'block';
          this.treeControl
            .getDescendants(n)
            .forEach((_n) => (_n['display'] = 'block'));
        } else {
          if (
            this.treeControl
              .getDescendants(n)
              .some(
                (_n) =>
                  _n.name?.toLowerCase().indexOf(keyword.toLowerCase()) !==
                    -1 &&
                  _n.searchText
                    ?.toLowerCase()
                    .indexOf(keyword.toLowerCase()) !== -1
              )
          ) {
            [node, n].forEach((i) => this.treeControl.expand(i));
            n['display'] = 'block';
          } else {
            n['display'] = 'none';
          }
        }
      } else {
        if (
          n.display == undefined &&
          n.searchText.toLowerCase().indexOf(keyword.toLowerCase()) == -1
        ) {
          n['display'] = 'none';
        } else {
          this.treeControl.expand(node);
          n['display'] = 'block';
        }
      }
    });
  }

  showGovFilter = true;

  markLocsOnOpenClose() {
    this.showError = false;
    this._testxxx.forEach((node) => this.selectAllLocs(node, false));
    if (
      (this.isMultiSelectionPossible && this.selectedLocs?.length) ||
      (!this.isMultiSelectionPossible && this.selectedLocs?.length == 1)
    ) {
      const locIds = this.selectedLocs.map(({ accountNumber }) => {
        return accountNumber;
      });

      this._testxxx.forEach((node) => this.selectEachLoc(node, true, locIds));
      this.dataSource.data = this.testxxx = JSON.parse(
        JSON.stringify(this._testxxx)
      );
      //expand sub tree if the node is selected

      this.treeControl.dataNodes.forEach((n, i) => {
        this.treeControl.getDescendants(n).forEach((subNode) => {
          !subNode.expandable &&
            !!subNode.checked &&
            this.treeControl.expandDescendants(this.treeControl.dataNodes[i]);
        });
      });

      this.cd.detectChanges();
    } else {
      this.dataSource.data = this.testxxx = JSON.parse(
        JSON.stringify(this._testxxx)
      );
    }

    this.showGovFilter = this.testxxx.some(
      (node) => node.hasGovernmentLocs || node.isGovernmentLocation
    );
  }

  checkBtnVisibility() {
    return !!!_.chain(this.testxxx)
      .map((obj) => this.getSelectedLocs(obj))
      .flatten()
      .filter((res) => !!res)
      .value().length;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.routerSub?.unsubscribe();
    this.baseSub?.unsubscribe();
  }
}
